import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ToastAction,
  ToastItem,
  ToastService,
  ToastType,
} from '../../services/toast-service';
import { Icon } from '../icon/icon';
import { IconName } from '../icon/icon-name';

/** DS status glyphs: checkmark for success; the error glyph (recoloured by the
 *  kind's status token) covers error/warning/info — the sprite has no
 *  dedicated info/warning toast icons yet. */
const STATUS_ICON: Record<ToastType, IconName> = {
  success: 'icon-checkmark',
  error: 'icon-error',
  warning: 'icon-error',
  info: 'icon-error',
};

/**
 * Global toast stack (mounted once in app.html). Renders whatever ToastService
 * holds — all state lives in the service; call `ToastService.show()` to toast.
 */
@Component({
  selector: 'app-toast',
  imports: [TranslocoDirective, Icon],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast {
  private readonly toastService = inject(ToastService);

  protected readonly toasts = this.toastService.toasts;

  protected statusIcon(type: ToastType): IconName {
    return STATUS_ICON[type];
  }

  protected dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  protected runAction(toast: ToastItem, action: ToastAction): void {
    action.run?.();
    this.toastService.dismiss(toast.id);
  }
}
